<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <div class="posi-from">
          <div class="posi-item col3 mt0" v-if="!info.disable">
            <div class="posi-item-title">提现方式</div>
            <div class="sex">
              <div
                class="sex-item"
                @click="handleType(item)"
                v-for="item in typeArr"
                :key="item.id"
              >
                <div
                  :class="[
                    'sex-yuan',
                    item.id == fromData.ways ? 'sex-active' : '',
                  ]"
                ></div>
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="posi-item col3" v-if="!info.disable&&fromData.ways==1">
            <div class="posi-item-title">微信手机号</div>
            <div class="posi-item-input pl1">{{account.wechat}}</div>
          </div>
          <div class="posi-item col3" v-if="!info.disable&&fromData.ways==2">
            <div class="posi-item-title">支付宝账号</div>
            <div class="posi-item-input pl1">{{account.alipay}}</div>
          </div>
          <div class="posi-item col3" v-if="!info.disable&&fromData.ways==3">
            <div class="posi-item-title">银行卡信息</div>
            <div class="posi-item-input pl2">
              <div>银行卡户名：{{account.bank_name}}</div>
              <div>银行卡账号：{{account.bank_cardno}}</div>
              <div>所属银行：{{account.bank_type}}</div>
            </div>
          </div>
          <div class="posi-item col3" v-if="!info.disable">
            <div class="posi-item-title">交易单号</div>
            <div class="posi-item-input">
              <el-input
                v-model="fromData.orderno"
                placeholder="请输入交易单号"
              ></el-input>
            </div>
          </div>
          <div class="posi-item col3" v-if="info.disable">
            <div class="posi-item-title">基本信息</div>
            <div class="posi-item-input jichu">
              <div>
                <span>提现方式：</span>
                <p>
                  {{
                    info.info.ways == 1
                      ? "人工-微信转账"
                      : info.info.ways == 2
                      ? "支付宝转账"
                      : info.info.ways == 3
                      ? "银行卡转账"
                      : "自动-微信转账 "
                  }}
                </p>
              </div>
              <div>
                <span>交易单号：</span>
                <p>{{ info.info.orderno }}</p>
              </div>
            </div>
          </div>
          <div class="posi-item col3 mt0">
            <div class="posi-item-title">转账截图</div>
            <div class="posi-item-input">
              <el-upload
                class="upload-demo"
                drag
                :action="uploadimg"
                :headers="headers"
                :show-file-list="false"
                :on-success="handleSubmitSuccess"
                v-if="!info.disable"
              >
                <img
                  class="zp"
                  v-if="fromData.tradeimages"
                  :src="urls + fromData.tradeimages"
                  alt=""
                />
                <div v-else class="scpz">
                  <img src="@/assets/images/basicBusiness/scpz.png" alt="" />
                  <div>请点击上传附件或拖动到此位置上传</div>
                </div>
              </el-upload>
              <img
                class="h201"
                v-else
                :src="urls + fromData.tradeimages"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div class="posi-btn" v-if="!info.disable">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确定" }}</div>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  name: "Popup",
  props: ["dataVal"],
  data() {
    return {
      fromData: {
        id: "",
        ways: 1,
        tradeimages: "",
        orderno: "",
      },
      urls: this.imgurl,
      headers: {
        token: window.localStorage.getItem("token"),
        type: window.localStorage.getItem("type"),
      },
      typeArr: [
        {
          id: 1,
          name: "微信转账",
        },
        {
          id: 2,
          name: "支付宝转账",
        },
        {
          id: 3,
          name: "银行卡转账",
        },
      ],
      channelArr: [],
      info: "",
      account:""
    };
  },
  mounted() {},
  methods: {
    handleType(item) {
      this.fromData.ways = item.id;
    },
    //提交
    async handleSubmit() {
      let res = await this.$api.fenxiaoCashoutupload({
        ...this.fromData,
      });
      if (res.code == 1) {
        let obj = {
          submitFlag: true,
        };
        this.$emit("uploadCredentialsCell", obj);
        this.$message.success("提交成功");
      }
    },
    //关闭
    handleClose() {
      let obj = {
        submitFlag: false,
      };
      this.$emit("uploadCredentialsCell", obj);
    },
    handleSubmitSuccess(res) {
      this.fromData.tradeimages = res.data.imgsrc;
    },
    async fenxiaoGetaccount(id){
      let res = await this.$api.fenxiaoGetaccount({
        saler_id:id
      })
      if (res.code==1) {
        this.account = res.data;
      }
    }
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        this.fenxiaoGetaccount(newVal.info.saler_id);
        this.info = newVal;
        this.fromData.id = newVal.id;
        this.fromData.orderno = newVal.info.orderno;
        this.fromData.ways = newVal.info.ways;
        this.fromData.tradeimages = newVal.info.tradeimages;
        
        if (newVal.disable) {
        } else {
        }
      },
      deep: true,
    },
  },
};
</script>
  <style>
.el-select-dropdown {
  z-index: 10000 !important;
}
</style>
    <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.pl1 {
  height: 60px;
  border-radius: 10px;
  background: #f2f2f7;
  line-height: 60px;
  font-size: 14px;
  padding-left: 51px;
}
.pl2 {
  height: 60px;
  border-radius: 10px;
  background: #f2f2f7;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  div:nth-child(2) {
    margin: 0 50px;
  }
}
.h201 {
  display: block;
  height: 381px;
  width: auto;
  margin: 0 auto;
}
.posi-center {
  width: 55.886vw;
  height: 70vh;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  .scpz {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #aeaeb2;
    img {
      width: 35px;
      height: 35px;
      margin-right: 7px;
    }
  }
  .posi-over {
    font-size: 16px;
    color: #000000;
    padding: 15px 35px 0;
    height: 52vh;
    overflow: auto;
    .posi-from {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .posi-item {
        width: 360px;
        margin-bottom: 30px;
        /deep/.upload-demo {
          width: 100%;
          .el-upload {
            width: 100%;
          }
          .el-upload-dragger {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f2f2f7;
          }
          .zp {
            height: 100%;
            width: auto;
          }
        }
        .posi-item-title {
          color: #606060;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 11px;
          @include flex-center(flex-start, center);
          &::before {
            content: "";
            display: block;
            width: 4px;
            height: 18px;
            border-radius: 2px;
            background-color: $y-color;
            margin-right: 7px;
          }
        }
        /deep/.posi-item-input {
          width: 100%;

          .el-select {
            width: 100%;
          }
          input {
            width: 100%;
            height: 52px;
            background-color: #f5f6fa;
            //   color: #a6a6a6;
            color: #000;
            font-size: 14px;
            border: 1px solid #f5f6fa;
            outline: none;
            padding-left: 16px;
          }
          /deep/.el-input__inner {
            height: 52px;
            line-height: 52px;
            background-color: #f5f6fa;
            color: #000;
            font-size: 14px;
            border: 1px solid #f5f6fa;
          }
        }
        .jichu {
          display: flex;
          div {
            display: flex;
            align-items: center;
            font-size: 13px;
            span {
              color: #8e8e93;
            }
            &:first-child {
              margin-right: 66px;
            }
          }
        }
        .sex {
          width: 100%;
          margin: 25px 0 30px;
          background-color: #f2f2f7;
          height: 60px;
          @include flex-center(center, center);
          border-radius: 5px;
          .sex-item {
            @include flex-center(center, center);
            color: #000000;
            font-size: $f-size-14;
            cursor: pointer;
            margin-right: 4.828vw;
            .sex-yuan {
              width: 10px;
              height: 10px;
              border: 1px solid #aeaeb2;
              border-radius: 50%;
              margin-right: 6px;
            }
            .sex-active {
              background-color: $y-color;
              border: 1px solid $y-color;
            }
            &:last-child {
              margin-right: 0;
            }
            &:hover {
              color: $y-color;
            }
          }
        }
      }
      .col3 {
        width: 100%;
        margin-right: 0;
      }
      .col1 {
        width: calc((100% - 50px) / 3);
        margin-right: 25px;
      }
      .col2 {
        width: calc(((100% - 25px) / 3 * 2));
      }
      .mr0 {
        margin-right: 0;
      }
      .mt0 {
        margin-bottom: 0;
      }
    }
  }
  .posi-btn {
    padding-top: 40px;
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #4a4b9d;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>